export enum SituacaoComodato {

	PENDENTE = <number>1,
	RECOLHER = <number>2,
	ENCERRADO = <number>3,
}
